import { httpClient } from '../http/httpClient'
import { TeamGetResponse } from './getTeams'

export interface TeamBySupervisorParams {
  supervisorIds?: string
  limit?: number
  skip?: number
  sort?: string
  order?: string
}

export const getTeamsBySupervisorIds = async (
  params: TeamBySupervisorParams,
) => {
  const { data } = await httpClient.get<TeamGetResponse>(`/team`, {
    params,
  })

  return data
}
